import gsap from 'gsap';

const open = gsap.timeline({
  paused: true,
});

open
  .staggerTo(
    '.collapse',
    0.4,
    {
      opacity: 1,
      ease: 'easeInOut',
      display: 'flex',
    },
    0.1
  )
  .staggerTo(
    '.header__menu .animated-menu-item',
    0.5,
    {
      x: 0,
      opacity: 1,
      ease: 'easeInOut',
    },
    0.1
  )
  .to(
    '.site-move',
    0.6,
    {
      opacity: 1,
      y: 0,
      ease: 'easeInOut',
    },
    '<'
  )
  .to(
    '.translation',
    0.6,
    {
      opacity: 1,
      y: 0,
      ease: 'easeInOut',
    },
    0.6,
    '<'
  )
  .to(
    '.collapse__close',
    0.4,
    {
      opacity: 1,
      ease: 'easeInOut',
    },
    '<'
  );

const close = gsap.timeline({
  paused: true,
});

close
  .staggerTo('.collapse__close', 0.2, {
    opacity: 0,
    ease: 'easeInOut',
  })
  .to(
    '.site-move',
    0.4,
    {
      opacity: 1,
      y: 200,
      ease: 'easeInOut',
    },
    '<'
  )
  .to(
    '.translation',
    0.4,
    {
      opacity: 1,
      y: 200,
      ease: 'easeInOut',
    },
    '<'
  )
  .staggerTo(
    '.header__sub-menu',
    0.3,
    {
      y: 100,
      opacity: 0,
      ease: 'easeInOut',
    },
    '0.1',
    '<'
  )
  .staggerTo(
    '.header__menu .animated-menu-item',
    0.1,
    {
      x: 100,
      opacity: 0,
      ease: 'easeInOut',
    },
    '0.1',
    '<'
  )
  .staggerTo(
    '.collapse',
    0.3,
    {
      x: 0,
      opacity: 0,
      ease: 'easeInOut',
      display: 'none',
    },
    '<'
  );

const timelineToggle = (timeline) => {
  if (timeline.progress() < 1) {
    timeline.play();
  } else {
    timeline.restart();
  }
};

const menuScroll = () => {
  // if(window.innerWidth < 767) {
  if ($('.navbar-toggler').hasClass('active')) {
    // window.scroll_position = $(window).scrollTop();
    $('body').css('overflow', 'hidden').css('width', '100%');

    $('.header').addClass('active');
    $('.navbar-toggler').addClass('toggleClose');
  } else {
    $('body').css('overflow', '').css('width', 'auto');

    $('.header').removeClass('active');
    $('.navbar-toggler').removeClass('toggleClose');
    // $(window).scrollTop(window.scroll_position);
  }
  // }
};

const removeItems = () => {
  const close = gsap.timeline({
    paused: true,
  });

  close.staggerTo(
    '.sub-menu .nav-item',
    0.3,
    {
      opacity: 0,
      ease: 'easeInOut',
    },
    0.05
  );

  close.play();

  setTimeout(() => {
    $('.sub-menu').html('');
  }, 700);
};

function closeMenu() {
  $('.sub-menu').html('');
  $('.dropdown-menu').hide();
  $('.dropdown-menu-toggler').removeClass('active');
  $('.dropdown-menu-toggler .icon')
    .removeClass('icon-angle-right')
    .addClass('icon-angle-down');
  $('.navbar-toggler').removeClass('toggleClose').removeClass('active');
}

$(document).on('click', '.navbar-toggler', function () {
  if ($(this).hasClass('animating')) {
    return;
  } else {
    $(this).addClass('animating');
    $(this).toggleClass('active');

    // active sub item? Collapse sub menu
    $('.header__menu .current-menu-parent').next().trigger('click');

    if ($(this).hasClass('toggleClose')) {
      closeMenu();
      removeItems();
      timelineToggle(close);
    } else {
      timelineToggle(open);
    }
    menuScroll();
  }

  const timeout = (toggler) => {
    toggler.removeClass('animating');
  };

  setTimeout(timeout, 700, $(this));
});

$(document).keydown(function (event) {
  if (event.keyCode == 27) {
    if ($('.collapse').is(':visible')) {
      closeMenu();
      removeItems();
      timelineToggle(close);
      menuScroll();
    }
  }
});

// check if string contains substring
function checkExistOrnot(str1, str2) {
  if (str1.indexOf(str2) >= 0) return true;
  else return false;
}

function addActiveClassByLang(value) {
  $('.header__menu a.nav-link').attr('href', function (i, h) {
    if (checkExistOrnot(h, value)) {
      $(this).addClass('current-menu-item');
    }
  });

  $('.rw-filter__nav a').attr('href', function (i, h) {
    if (checkExistOrnot(h, value)) {
      $(this).parent().addClass('current-menu-item');
    }
  });
}

// Add long parameter when it does not exist
if($('.check-current-lang-en').length){
  if (window.location.href.indexOf('koopwoningen') > -1) {
    addActiveClassByLang('/koopwoningen');
  }

  if (window.location.href.indexOf('huurwoningen') > -1) {
    addActiveClassByLang('/huurwoningen');
  }

  if (window.location.href.indexOf('nieuwbouw') > -1) {
    addActiveClassByLang('nieuwbouw');
  }

  if (window.location.href.indexOf('bedrijfsaanbod') > -1) {
    addActiveClassByLang('bedrijfsaanbod');
  }
}
